import { audioContext } from './context';
import { recordedSheets } from './recorded';
import { SheetVoice, WebVoice } from './voice';

let voice: SheetVoice | undefined;

/**
 * Agent Alex says one recorded line outside a mission (the mission report, the elevator), with
 * captions that follow; resolves when done. Starting another line stops this one.
 */
export async function sayAlex(text: string): Promise<void> {
  voice ??= new SheetVoice(audioContext, new WebVoice(audioContext), recordedSheets());
  // The sheets load once per page; wait for them so the line is in Alex's recorded voice.
  await recordedSheets();
  await new Promise((resolve) => setTimeout(resolve, 0));
  await voice.play([{ kind: 'say', text }]);
}

/** Stops Alex's line (leaving the screen). */
export function stopAlex(): void {
  voice?.stop();
}
